import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from '../../../../common/constants/errors';

export const createFinalPDF = ({shumaID}) => dispatch => {
  const data = {shumaID: parseInt(shumaID, 10)};
  return axios.post(api.CREATE_FINAL_PDF, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body.fileData;
    })
};
